import { useMutation, useQueryClient } from '@tanstack/react-query';
import { revokeUserSessions } from '../services/users';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';

export const useRevokeSessionsMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, string>({
        mutationFn: (id) => revokeUserSessions(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({ queryKey: userKeys.detail(id) });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
